import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  SelectWithSearch,
  InputMaskCustom,
  InputCustom,
  Loading,
  TextArea
} from "../components"
import Layout from "../views/Layout"
import * as ApiHelper from "../ApiHelper"
import Util from "../Util"
import { LoadModalWithLabel } from "./modais"
import RecibosModal from "./modais/RecibosModal"
import Moment from "moment"
class ReciboDeAtestoDeServicoForm extends Component {
  constructor() {
    super()
    this.onChangeCPF = this.onChangeCPF.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeCPFServidor = this.onChangeCPFServidor.bind(this)
    this.onChangeNomeServidor = this.onChangeNomeServidor.bind(this)
    this.onChangeDataRecibo = this.onChangeDataRecibo.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.resetForm = this.resetForm.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.onChangeObservacao = this.onChangeObservacao.bind(this)
    this.toggleReimpressaoModal = this.toggleReimpressaoModal.bind(this)
    this.hideReimpressaoModal = this.hideReimpressaoModal.bind(this)
    this.onChangeUnidadeOrcamentaria = this.onChangeUnidadeOrcamentaria.bind(
      this
    )
    this.state = {
      nome: "",
      showLoad: false,
      cpf: "",
      unidade: "",
      nomeServidor: "",
      cpfServidor: "",
      dataRecibo: Moment().format('YYYY-MM-DD'),
      observacao: "",
      unidades: [],
      contrato: "",
      contratos: [],
      showForm: false,
      showReimpressaoModal: false
    }
  }
  resetForm() {
    this.setState({
      nome: "",
      cpf: "",
      unidade: "",
      numeroContrato: "",
      nomeServidor: "",
      dataRecibo: Moment().format('YYYY-MM-DD'),
      observacao: "",
      cpfServidor: ""
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  componentWillMount() {
    this.getContratos()
  }
  onChangeContrato(event) {
    this.setState({
      contrato: event,
      contrato_idError: ""
    })
  }
  onChangeCPF(event) {
    var newValue = event.target.value
    this.setState({
      cpf: newValue,
      cpf_funcionariaError: ""
    })
  }
  onChangeCPFServidor(event) {
    var newValue = event.target.value
    this.setState({
      cpfServidor: newValue,
      cpf_secretariaError: ""
    })
  }
  onChangeNome(event) {
    var newValue = event.target.value
    this.setState({
      nome: newValue,
      nome_funcionariaError: ""
    })
  }
  onChangeNomeServidor(event) {
    var newValue = event.target.value
    this.setState({
      nomeServidor: newValue,
      nome_servidorError: ""
    })
  }
  onChangeUnidadeOrcamentaria(selectedItem) {
    var newValue = selectedItem.value
    this.setState({
      unidade: newValue,
      unidade_orcamentariaError: ""
    })
  }
  onChangeDataRecibo(value) {
    var newValue = Moment(value).format('YYYY-MM-DD')
    this.setState({
      dataRecibo: newValue
    })
  }
  onChangeObservacao(event) {
    var newValue = event.target.value
    this.setState({
      observacao: newValue,
      observacaoError: ""
    })
  }
  toggleReimpressaoModal() {
    this.setState({
      showReimpressaoModal: !this.state.showReimpressaoModal
    })
  }
  hideReimpressaoModal() {
    this.setState({
      showReimpressaoModal: false
    })
  }
  getContratos() {
    ApiHelper.getAllContratos((contratos, error) => {
      if (contratos) {
        var mapped = Util.mapContratos(contratos)
        mapped.shift()
        this.setState({
          contratos: mapped,
          showForm: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  sendForm(event) {
    event.preventDefault()
    var parameters = {
      nome_funcionaria: this.state.nome,
      cpf_funcionaria: Util.unmaskField(this.state.cpf),
      contrato_id:
        this.state.contrato === undefined || this.state.contrato === null
          ? null
          : this.state.contrato.value,
      nome_servidor: this.state.nomeServidor,
      cpf_secretaria: Util.unmaskField(this.state.cpfServidor),
      data_recibo: this.state.dataRecibo,
      observacoes:
        this.state.observacao === undefined || this.state.observacao === null
          ? undefined
          : this.state.observacao
    }
    this.toggleLoadModal()
    ApiHelper.getReciboDeAtestoDeServicos(parameters, (response, error) => {
      this.toggleLoadModal()
      if (error) {
        this.handleErrors(error)
      } else {
        var url = URL.createObjectURL(response)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Recibo de atesto de serviço.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        this.resetForm()
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    if (!this.state.showForm) {
      return (
        <Layout>
          <Loading />
        </Layout>
      )
    }
    return (
      <Layout>
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <RecibosModal
          callBack={this.hideReimpressaoModal}
          show={this.state.showReimpressaoModal}
          onClose={this.toggleReimpressaoModal}
        />
        <div className="card card-plain">
          <div className="card-header" data-background-color="as-blue">
            <button
              className="btn btn-primary pull-right"
              data-background-color="green"
              onClick={this.toggleReimpressaoModal}
            >
              Reimprimir recibos
            </button>
            <h4 className="title">Recibo de atesto de serviço</h4>
            <p className="category">Atestado de serviço realizado</p>
          </div>
          <div className="card-content">
            <div className="row">
              <SelectWithSearch
                sizeClass="col-md-8"
                options={this.state.contratos}
                label="Contrato"
                error={this.state.contrato_idError}
                placeholder="Selecione um contrato ou deixe em branco para selecionar todos"
                onChange={this.onChangeContrato}
                value={this.state.contrato}
              />
            </div>
            <div className="row">
              <InputCustom
                error={this.state.nome_funcionariaError}
                type="text"
                onChange={this.onChangeNome}
                sizeClass="col-md-4"
                label="Nome do(a) funcionário(a) que realizou o serviço"
                value={this.state.nome}
              />
              <InputMaskCustom
                mask="999.999.999-99"
                error={this.state.cpf_funcionariaError}
                sizeClass="col-md-2"
                label="CPF do(a) funcionário(a)"
                type="text"
                onChange={this.onChangeCPF}
                value={this.state.cpf}
              />
            </div>
            <div className="row">
              <InputCustom
                error={this.state.nome_servidorError}
                type="text"
                onChange={this.onChangeNomeServidor}
                sizeClass="col-md-4"
                label="Nome do servidor"
                value={this.state.nomeServidor}
              />
              <InputMaskCustom
                mask="999.999.999-99"
                error={this.state.cpf_secretariaError}
                sizeClass="col-md-2"
                label="CPF do servidor"
                type="text"
                onChange={this.onChangeCPFServidor}
                value={this.state.cpfServidor}
              />
            </div>
            <div className="row">
              <InputCustom
                  sizeClass="col-md-3"
                  type="date"
                  label="Data"
                  onChange={this.onChangeDataRecibo}
                  value={this.state.dataRecibo}
              />
            </div>
            <div className="row">
              <TextArea
                error={this.state.observacaoError}
                sizeClass="col-md-12"
                label="Observação"
                onChange={this.onChangeObservacao}
                value={this.state.observacao}
              />
            </div>
            <div className="row">
              <button
                onClick={this.sendForm}
                type="submit"
                className="btn btn-primary pull-left"
                data-background-color="as-blue"
              >
                Gerar
              </button>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
export default withRouter(ReciboDeAtestoDeServicoForm)



// WEBPACK FOOTER //
// ./src/views/ReciboDeAtestoDeServicoForm.js